export default "__VITE_ASSET__feb9b7b2__"